module.exports = __webpack_public_path__ + "static/img/16.a6f18a61.png";